<template>
  <FpvReportsTable
    :fpv-reports="openFpvReports"
    :is-preview="true"
    :refresh-function="refreshTable"
    :loading="loading"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { toQueryString } from '@/helpers';
import FpvReportsTable from '@/components/roboInvesting/FpvReportsTable';

export default {
  name: 'OpenFpvReportsTab',
  components: {
    FpvReportsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.fpvReportsStore.openLoading,
      openFpvReports: state => state.fpvReportsStore.openFpvReports,
    }),
  },
  mounted() {
    this.getOpenFpvReports();
  },
  methods: {
    ...mapActions(['getOpenFpvReports']),
    refreshTable(search) {
      const query = toQueryString({
        userId: search,
      });
      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.getOpenFpvReports(query);
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/roboInvesting/OpenFpvReportsTab.vue